import { Component, OnInit, Input, Renderer2, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'dhhp-card-actions',
  template: `<mat-card-actions #refactions>
  <ng-content></ng-content>
</mat-card-actions>`
})
export class DhhpCardActionsComponent implements OnInit,AfterViewInit {
  @Input() class:string;
  @ViewChild('refactions',{read:ElementRef}) refactions: ElementRef;
  constructor(private renderer:Renderer2) { }

  ngOnInit() {
    if(this.class == undefined) {
      this.class = 'mat-card-actions'
    } else {
      this.class = this.class + ' mat-card-actions'
    }
  }
  ngAfterViewInit():void {
    this.renderer.removeAttribute(this.refactions.nativeElement.parentNode,'class')
    if(this.class != undefined){
    this.renderer.setAttribute(this.refactions.nativeElement,'class',this.class)
    }
    this.renderer.setAttribute(this.refactions.nativeElement,'_ngcontent-c6','')

  }
}
